import { Card, Col, Row, Spin, Statistic } from "antd";
import React, { useState } from "react";

import { useEndTime, useStartTime } from "../DateContext/DateContext";
import useQuickEngagement from "./useQuickEngagement";

/**
 * platform: "discord" or "slack"
 * channelId: the channel id to filter by
 */
type Props = {
  platform: string;
  channelId?: string;
};

function QuickEngagementCard(props: Props) {
  const { platform, channelId } = props;
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();
  const { parentCount, reactionCount, threadMessageCount, loading } =
    useQuickEngagement(startTime, endTime, platform, channelId);

  return (
    <Card
      title="Quick engagement metrics"
      bordered={false}
      className="card-engagement"
    >
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          <Col lg={12} sm={12}>
            <Statistic
              title="Total messages"
              value={parentCount + threadMessageCount}
            />
          </Col>
          <Col lg={12} sm={12}>
            <Statistic title="# of channel messages" value={parentCount} />
          </Col>
          <Col lg={12} sm={12}>
            <Statistic title="# of reactions" value={reactionCount} />
          </Col>
          <Col lg={12} sm={12}>
            <Statistic
              title="# of thread messages"
              value={threadMessageCount}
            />
          </Col>
        </Row>
      </Spin>
    </Card>
  );
}

export default QuickEngagementCard;
